import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTeacherProfile } from '@services/registry';

export function useUpdateTeacher({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ teacherId, patch }) => {
            return await updateTeacherProfile({ tenantId, teacherId, patch });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['teachers', tenantId] });
            qc.invalidateQueries({ queryKey: ['teacherKpis', tenantId] });
        },
    });
}

